module.exports = __webpack_public_path__ + "static/pic1-c497f8445dbd9f165c62846b4234bb49.png";